// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export
export { default as routes } from './routes.js'




// WEBPACK FOOTER //
// ./src/app/vcro/index.js